module.exports = __webpack_public_path__ + "img/Box-6.80d85506.png";